/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Element } from 'react';

import React from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import {
  LAT,
  LNG,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/formInputNames.js';
import Field from '#components/pages/Models/Model/sections/support/forms/Field/index.js';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import SiteMap from './SiteMap/index.js';
// import SiteMap from './AltSiteMap/index.jsx';

type Props = {|
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const SiteCoordinatesSection = ({ form, heading, onBack, onNext }: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    <Form noValidate>
      <FormGroup tag="fieldset">
        <legend>
          Site Coordinates <Tip tipId="siteCoordinates" />
        </legend>
        <Row>
          <Col lg="3" md="4">
            <FormGroup>
              <Label htmlFor={LAT}>Latitude</Label>
              <Field form={form} id={LAT} name={LAT} type="text" component={RenderInput} />
              <FieldFeedback name={LAT} form={form} />
            </FormGroup>
            <FormGroup>
              <Label htmlFor={LNG}>Longitude</Label>
              <Field form={form} id={LNG} name={LNG} type="text" component={RenderInput} />
              <FieldFeedback name={LNG} form={form} />
            </FormGroup>
          </Col>
          <Col lg="9" md="8">
            <SiteMap form={form} />
          </Col>
        </Row>
      </FormGroup>
      <BackButton onClick={onBack} />
      <NextButton onClick={onNext} />
    </Form>
  </div>
);

export default SiteCoordinatesSection;
